import { track } from '@hotelplan/libs.tracking-events';

export const recommendationsLoadMoreTracking = (language?: string) => {
  track({
    event: `load_more`,
    action: `load more`,
    label: `Mehr Erlebnisreisen anzeigen`,
    category: undefined,
    component: `show-more-link`,
    position: `product-recommender`,
    language,
    _clear: true,
  });
};

export const recommendationsOpenMapTracking = (language?: string) => {
  track({
    event: `open_map`,
    action: `open`,
    label: `Karte öffnen auf Geo Seite`,
    category: undefined,
    component: `map-icon`,
    position: `product-recommender`,
    language,
    _clear: true,
  });
};
